import React, {Dispatch, useState} from "react"
import {IMedicalInstitution} from "../../../../models/medical"
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux"
import useWindowSize from "../../../../hooks/useWindowSize"
import LineMenu from "../LineMenu"
import {
  deleteMedicalInstitution,
  fetchMedicalInstitutions,
  setCurrentPage
} from "../../../../store/actions/medicalActions"
import Modal from "../../modals/Modal"
import ModalEditMedicalInstitution from "../../modals/ModalEditMedicalInstitution/ModalEditMedicalInstitution"
import classes from "./MedicalInstitutionLine.module.scss"

interface IMedicalInstitutionLineProps {
  item: IMedicalInstitution,
  editSuccess: Dispatch<any>
  deleteSuccess: Dispatch<any>
}

function MedicalInstitutionLine({item, editSuccess, deleteSuccess}: IMedicalInstitutionLineProps) {

  const dispatch = useAppDispatch()
  const windowSize = useWindowSize()
  const {pageSize} = useAppSelector(state => state.medical)
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalDeleteShown, modalDeleteToggle] = useState(false)

  const deleteHandler = async () => {
    const isDeleted = await dispatch(deleteMedicalInstitution(item.medical_uuid))

    if (isDeleted) {
      modalDeleteToggle(false)
      deleteSuccess(true)
      dispatch(setCurrentPage(1))
      await dispatch(fetchMedicalInstitutions({page: 1, pageSize}))
    }
  }

  const modalEdit = modalEditShown &&
    <ModalEditMedicalInstitution
      close={() => modalEditToggle(false)}
      editSuccess={editSuccess}
      editableItem={item}
    />

  const modalDelete = modalDeleteShown &&
    <Modal
      title={"Удалить адрес?"}
      close={() => modalDeleteToggle(false)}
      dialogSizeSuffix={"w350"}
      submitClick={deleteHandler}
      submitText={"Да, удалить"}
      cancelClick={() => modalDeleteToggle(false)}
      headerAlignCenter={true}
    />

  const menuList = [
    {
      id: 1,
      text: "Редактировать",
      onClick: () => modalEditToggle(true)
    },
    {
      id: 2,
      text: "Удалить",
      type: "delete",
      onClick: () => modalDeleteToggle(true)
    }
  ]

  const address = []

  if (item.city) {
    address.push(item.city)
  }

  if (item.address) {
    address.push(item.address)
  }

  if (item.flat)
    address.push(`кв. ${item.flat}`)

  return(
    <>
      <div className={classes.wrap}>
        <div className={[classes.field, classes.field_name].join(" ")}>
          <div className={classes.field_value}>{item.medical_name}</div>
          {windowSize.width < 768 && <div className={classes.field_label}>{address.length ? address.join(", ") : "-"}</div>}
        </div>
        {windowSize.width >= 768 && <div className={classes.field}>
          <div className={classes.field_value}>
            {address.length ? address.join(", ") : "-"}
          </div>
        </div>}
        <div className={[classes.field, classes.field_menu].join(" ")}>
          <LineMenu items={menuList}/>
        </div>
      </div>
      {modalEdit}
      {modalDelete}
    </>
  )
}

export default MedicalInstitutionLine